import { UserType } from './user';
import { ValueOf, CommonFieldType } from './utils';

export type InviteCodeFilters = {
  status: string;
};
export type InviteCodeFilterKey = keyof InviteCodeFilters;
export type InviteCodeFilterValue = ValueOf<InviteCodeFilters>;

export type InviteCodeType = CommonFieldType & {
  refCode: string;
  refToUserId?: string | null;
  refToUser?: UserType | null;
  refUsedAt?: string | null;
  status: InviteCodeStatus;
  refByUser: UserType | null;
};

export type InviteCodeBadgeType = {
  total: number;
  pending: number;
  approved: number;
  rejected: number;
};

export enum InviteCodeStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}
